import AccountLockup from '@/components/financialEntities/AccountLockup';
import ShareSettingsSection from '@/components/settings/ShareSettingsSection';
import { useMutation } from '@apollo/client';
import { Box, BoxProps } from '@chakra-ui/react';
import { ExternalFinancialEntity } from '@common/financialEntities';
import {
    SetFinancialEntityPermissionDocument,
    ShareStatus,
} from '@common/graphql/generated';
import { useMyAccounts } from '@common/react/accounts';
import { TOASTS } from '@common/toasts';
import Callout from '../common/Callout';
import { useToasts } from '../common/Toasts';

interface FinancialEntitiesPermissionsSectionProps extends BoxProps {
    activePartnershipId: string;
    showBalance?: boolean;
}

const FinancialEntitiesPermissionsSection = ({
    activePartnershipId,
    showBalance = false,
    ...props
}: FinancialEntitiesPermissionsSectionProps) => {
    const { showSuccessToast } = useToasts();
    const [setFinancialEntityPermission] = useMutation(
        SetFinancialEntityPermissionDocument
    );
    const myAccounts = useMyAccounts();
    if (!myAccounts || !activePartnershipId) return <></>;

    const update = async (
        account: ExternalFinancialEntity,
        shareStatus: ShareStatus
    ) => {
        await setFinancialEntityPermission({
            variables: {
                financialEntityId: account.id,
                partnershipId: activePartnershipId,
                shareStatus,
            },
        });
        showSuccessToast(
            TOASTS.updateFinancialEntityShareStatusSuccess({ shareStatus })
        );
    };

    return (
        <Box {...props}>
            {myAccounts.length === 0 && (
                <Callout>{`You don’t have any accounts yet`}</Callout>
            )}
            {myAccounts.map((account) => (
                <ShareSettingsSection
                    key={account.id}
                    el={
                        <AccountLockup
                            account={account}
                            showBalance={showBalance}
                            showLastUpdated={false}
                        />
                    }
                    shareStatus={account.shareStatus}
                    onChange={(shareStatus) => update(account, shareStatus)}
                    // Disable if partner is joint owner
                    isDisabled={!!account.jointOwnerPartnershipId}
                />
            ))}
        </Box>
    );
};

export default FinancialEntitiesPermissionsSection;
